package com.essntl.features.task.ui.alltasks

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.addedittask.AddEditTaskState
import com.essntl.features.task.ui.alltasks.components.AllTasksHeader
import com.essntl.features.task.ui.alltasks.components.NoTasksComponent
import com.essntl.features.task.ui.alltasks.components.TaskListColumn
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun AllTasksScreen(
    state: AllTasksState,
    onEvent: (AllTasksEvent) -> Unit,
    addEditTaskState: AddEditTaskState,
    onNavigation: (AllTasksNavigation) -> Unit,
) {
    val isLoading = remember(state) { state.isLoading }

    val isFailure = remember(state) { state.isFailure }

    Column(
        modifier = Modifier
            .fillMaxSize(),
    ) {
        AllTasksHeader(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
        )

        Spacer(modifier = Modifier.height(1.spacing))

        if (state.getAllTasks.data.isEmpty()) {
            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier
                    .fillMaxSize()
                    .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
                    .background(MaterialTheme.esColorScheme.bgSecondary),
            ) {
                if (isLoading) {
                    EsSpinner()
                } else if (isFailure) {
                    Text(
                        text = "Something goes wrong!",
                    )
                } else {
                    NoTasksComponent()
                }
            }
        } else {
            TaskListColumn(
                state = state,
                onEvent = onEvent,
                onNavigation = onNavigation,
                selectedTask = addEditTaskState.getTask.data ?: TaskModel.empty,
                isLoading = isLoading,
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f),
            )
        }
    }
}